// extracted by mini-css-extract-plugin
export default {"container":"link-module__container___vhfuW"};